<div class="recent-orders">
    <div class="title-buttons d-flex justify-content-between align-items-center">
        <strong>Subscriptions</strong>
    </div>

    <div class="table-responsive">
        <table class="table table-striped">
            <thead>
                <tr class="first last">
                    <th>User</th>
                    <th>Seller</th>
                    <th>Package</th>
                    <th>Amount (XAF)</th>
                    <th>Status</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody *ngIf="loading">
                <tr>
                    <td colspan="8" style="text-align: center">Loading ...</td>
                </tr>
            </tbody>
            <tbody *ngIf="!loading && subscriptions.length === 0">
                <tr>
                    <td colspan="8" style="text-align: center">No subscriptions found</td>
                </tr>
            </tbody>
            <tbody *ngIf="!loading && subscriptions.length > 0">
                <tr *ngFor="let subscription of subscriptions | paginate: config">
                    <td>{{ subscription.payment?.user?.firstName }} {{ subscription.payment?.user?.lastName }}</td>
                    <td>{{ subscription.seller?.companyName || subscription.seller?.firstName + ' ' + subscription.seller?.lastName }}</td>
                    <td>{{ subscription.packageTitle }}</td>
                    <td>{{ subscription.amount | number:'1.0-0' }}</td>
                    <td>
                        <span class="badge" [ngClass]="{
                            'bg-success': subscription.status === 'ACTIVE',
                            'bg-warning': subscription.status === 'INACTIVE',
                            'bg-danger': subscription.status === 'EXPIRED'
                        }">{{ subscription.status }}</span>
                    </td>
                    <td>{{ subscription.startDate | date:'shortDate' }}</td>
                    <td>{{ subscription.endDate | date:'shortDate' }}</td>
                    <td>
                        <a class="btn btn-sm btn-outline-primary" [routerLink]="['/admin', 'subscriptions', subscription.id]">
                            <i class="fa fa-eye"></i> View
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="toolbar" *ngIf="!loading && subscriptions.length > 0">
        <div class="pager">
            <pagination-controls
                class="pages"
                maxSize="5"
                previousLabel="Previous"
                nextLabel="Next"
                autoHide="true"
                id="subscriptions-listing"
                (pageChange)="pageChange($event)">
            </pagination-controls>
        </div>
    </div>
</div>